/*eslint-disable*/ export const messages = JSON.parse("{\"button.aria.loading\":[\"Laddar ...\"]}");
//# sourceMappingURL=messages.mjs.map